import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import ContentWrapper from "../../components/contentwrapper/ContentWrapper";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { FaRegHandPointRight } from "react-icons/fa";
import { toast } from "react-toastify";
import JoditEditor from "jodit-react";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import truncate from "html-truncate";
import { MDBBadge } from "mdbreact";
import { addFormData, fetchAllDataAPI, fetchAllDataByIDAPI, fetchAllReatedSubIssueMember } from "../../utils/api";

const AllTicket = () => {
    const editor = useRef(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const hrdata = localStorage.getItem("hrdata");
    const hruniqueid = localStorage.getItem("hruniqueid")
    const hrdataname = localStorage.getItem("hrdataname")
    const [show, setShow] = useState(false);
    const [validated, setValidated] = useState(false);
    const [values, setNewTicket] = useState({});
    const [members, setMembers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [ticket, setTicket] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [relatedIssues, setRelatedIssues] = useState([]);
    const [relatedSubIssues, setRelatedSubIssues] = useState([]);
    const [relatedSubIssuesId, setRelatedSubIssuesId] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const recordPerPage = 25;
    const lastIndex = currentPage * recordPerPage;
    const firstIndex = lastIndex - recordPerPage;

    const filteredTickets = ticket.filter((t) =>
        t.ticketids.toString().includes(searchQuery) || t.ticket_title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const records = filteredTickets.slice(firstIndex, lastIndex);
    const npage = Math.ceil(filteredTickets.length / recordPerPage);
    const numbers = [...Array(npage + 1).keys()].slice(1);

    useEffect(() => {
        if (hrdata) {
            navigate("/all-tickets");
            getAllTicket(hruniqueid);
            getAllIssues();
        } else {
            navigate("/");
        }
    }, [hrdata]);

    const getAllTicket = useCallback((hruniqueid) => {
        setIsLoading(true);
        fetchAllDataByIDAPI(`ticket-get-all-ticket/${hruniqueid}`)
            .then((res) => {
                if (res.data.status === 1) {
                    setTicket(res.data.ticketdata);
                } else {
                    setTicket([]);
                }
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
                toast.error("Error fetching ticket");
            });
    }, [hruniqueid]);

    const getAllIssues = () => {
        fetchAllDataAPI('ticket-get-all-realted-issues').then((res) => {
            if (res.data.status === 1) {
                setRelatedIssues(res.data.issues);
            }
        })
    }

    const handleRelatedIssues = e => {
        const issues = e.target.value;
        setRelatedSubIssuesId(e.target.value);
        fetchAllReatedSubIssueMember('ticket-get-all-realted-sub-issues', issues).then((res) => {
            if (res.data.status === 1) {
                setRelatedSubIssues(res.data.subissues)
                const memberOptions = res.data.member.map((item) => ({
                    value: item.ticket_member_id,
                    label: `${item.ticket_member_name} (${item.ticket_member_from})`
                }));
                setMembers(memberOptions);
            }
        })

    }
    const handleChange = (options) => {
        setSelectedMembers(options);
        setNewTicket({
            ...values,
            ticket_member_id: options.map((opt) => opt.value),
        });
    };
    const handleMemberSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        const form = event.currentTarget;

        if (form.checkValidity() === false || selectedMembers.length === 0) {
            toast.error("Please select at least one member.");
            setIsLoading(false);
            setValidated(true);
            return;
        }
        try {
            const formData = new FormData();
            formData.append("ticket_title", values.ticket_title);
            formData.append("ticket_priority", values.ticket_priority);
            formData.append("ticket_reated_issues", relatedSubIssuesId);
            formData.append("ticket_reated_sub_issues", values?.ticket_related_sub_issues);
            values.ticket_member_id.forEach((id, index) => {
                formData.append(`ticket_member_id[${index}]`, id);
            });
            formData.append("ticket_desc", values.ticket_desc);
            formData.append("ticket_created_by_id", hruniqueid);
            formData.append("ticket_created_by", `${hrdataname}(HR)`);

            addFormData("ticket-create-new-ticket", formData).then((res) => {
                if (res.data.status === 1) {
                    toast.success("Ticket has been created successfully!");
                    window.open("/all-tickets", "_self");
                    setShow(false);
                }
                else {
                    toast.error("Something went wrong!!");
                }
                setIsLoading(false);
            });
        }
        catch (error) {
            toast.error("Something went wrong!!");
            setIsLoading(false);
        }
        setValidated(true);
    };

    const handleInputs = (e) => {
        setNewTicket({
            ...values,
            [e.target.name]: e.target.value,
        });
    };

    const contentFieldChange = (data) => {
        setNewTicket({ ...values, ticket_desc: data });
    };
    const truncateText = (htmlContent, maxLength) => {
        return truncate(htmlContent, maxLength, { ellipsis: "..." });
    };
    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };
    return (
        <div className="misDashboard">
            <Modal
                size="lg"
                show={show}
                onHide={() => setShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
                className="createModel"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Create New Ticket
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleMemberSubmit}
                        method="post"
                    >
                        <Row className="mb-3">
                            <Form.Group as={Col} md="3" controlId="validationCustom01">
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="Enter the title"
                                    name="ticket_title"
                                    onChange={handleInputs}
                                />
                                <Form.Control.Feedback type="invalid">
                                    <FaRegHandPointRight /> Please provide a valid name
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="2" controlId="validationCustom05">
                                <Form.Label>Select Ticket Priority</Form.Label>
                                <Form.Select
                                    required
                                    placeholder="Select Priority"
                                    name="ticket_priority"
                                    onChange={handleInputs}>
                                    <option value="">Select Ticket Priority</option>
                                    <option value="High Priority">High Priority</option>
                                    <option value="Medium Priority">Medium Priority</option>
                                    <option value="Low Priority">Low Priority</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    <FaRegHandPointRight /> Please provide a valid Priority
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="2" controlId="validationCustom05">
                                <Form.Label>Select Topic</Form.Label>
                                <Form.Select
                                    required
                                    placeholder="Select Topic"
                                    name="ticket_related_issues"
                                    onChange={handleRelatedIssues}>
                                    <option value="">Select Topic</option>
                                    {relatedIssues?.map((issues, index) => (
                                        <option key={index} value={issues?.itissues_id}>{issues?.itissues_name}</option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    <FaRegHandPointRight /> Please provide a valid chanel name or source name
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="2" controlId="validationCustom05">
                                <Form.Label>Select Sub Topic</Form.Label>
                                <Form.Select
                                    required
                                    placeholder="Select Sub Topic"
                                    name="ticket_related_sub_issues"
                                    onChange={handleInputs}>
                                    <option value="">Select Sub Topic</option>
                                    {relatedSubIssues?.map((subissues, index) => (
                                        <option key={index} value={subissues?.sitissues_name}>{subissues?.sitissues_name}</option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    <FaRegHandPointRight /> Please provide a valid chanel name or source name
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="validationCustom02">
                                <Form.Label>Select Member</Form.Label>
                                <Select
                                    options={members}
                                    placeholder="Select Member..."
                                    isSearchable
                                    isMulti
                                    value={selectedMembers}
                                    onChange={handleChange}
                                    closeMenuOnSelect={false}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                                <Form.Control.Feedback type="invalid">
                                    <FaRegHandPointRight /> Please select at least one member.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                                as={Col}
                                md="12"
                                controlId="validationCustom07"
                                className="mt-2"
                            >
                                <Form.Label>Description</Form.Label>
                                <JoditEditor
                                    ref={editor}
                                    name="ticket_desc"
                                    onChange={contentFieldChange}
                                />
                            </Form.Group>
                        </Row>
                        {!isLoading ? (
                            <Button
                                type="submit"
                                className="btn btn-sm btn-primary rounded d-flex m-auto"
                            >
                                Submit
                            </Button>
                        ) : (
                            <div>Submitting...</div>
                        )}
                    </Form>
                </Modal.Body>
            </Modal>
            <Helmet>
                <title>SATKARTAR:ALL TICKET</title>
            </Helmet>
            <ContentWrapper>
                <div className="card p-2">
                    <div className="heading p-2 d-flex justify-content-between ticketborder mb-2">
                        <div className="d-flex gap-2">
                            <span className="btnticket">All Ticket</span>
                            <span className="btnticket">Calendar</span>
                        </div>
                        <div>
                            <Form.Control
                                type="text"
                                placeholder="Search by Ticket ID or Title"
                                value={searchQuery}
                                onChange={handleSearch}
                                className="mb-2"
                            />
                        </div>
                        <div>
                            <button
                                className="btnticket-primary"
                                onClick={() => setShow(true)}
                            >
                                + Create New Ticket
                            </button>
                        </div>
                    </div>
                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Ticket ID</th>
                                    <th>Ticket Priority</th>
                                    <th>Ticket Title</th>
                                    <th>Ticket Issues</th>
                                    <th>Ticket Sub Issues</th>
                                    <th>Desc</th>
                                    <th>Created Date</th>
                                    <th>Created Time</th>
                                    <th>Tag ID</th>
                                    <th>Ticket Status</th>
                                    <th>Created By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <>
                                        {[...Array(10)].map((_, index) => (
                                            <tr key={index}>
                                                {Array.from({ length: 13 }).map((_, idx) => (
                                                    <td key={idx}><Skeleton animation="wave" variant="text" /></td>
                                                ))}
                                            </tr>
                                        ))}
                                    </>
                                ) : records.length ? (
                                    records.map((record, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <Link to={`/ticket-detail/${record?.ticketids}`}>
                                                    <MDBBadge pill color="success" light>
                                                        {record?.ticketids}
                                                    </MDBBadge>
                                                </Link>
                                            </td>
                                            <td>{record?.ticket_title}</td>
                                            <td>{record?.ticket_priority}</td>
                                            <td>{record?.itissues_name}</td>
                                            <td>{record?.ticket_reated_sub_issues}</td>
                                            <td dangerouslySetInnerHTML={{ __html: truncateText(record?.ticket_desc, 80) }}></td>
                                            <td>{record?.ticket_create_date}</td>
                                            <td>{record?.ticket_create_time}</td>
                                            <td>
                                                {record?.names?.map((id, idx) => (
                                                    <span key={idx} className="badge me-1 border-radius-5 ttagname">
                                                        {id}
                                                    </span>
                                                ))}
                                            </td>
                                            <td>{record?.ticket_status}</td>
                                            <td>{record?.ticket_created_by}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={13}>Data not found...</td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>#</th>
                                    <th>Ticket ID</th>
                                    <th>Ticket Priority</th>
                                    <th>Ticket Title</th>
                                    <th>Ticket Issues</th>
                                    <th>Ticket Sub Issues</th>
                                    <th>Desc</th>
                                    <th>Created Date</th>
                                    <th>Created Time</th>
                                    <th>Tag ID</th>
                                    <th>Ticket Status</th>
                                    <th>Created By</th>
                                </tr>
                            </tfoot>
                        </Table>
                        <nav className="pagination-container">
                            <ul className="pagination align-items-center">
                                <li className="total-orders ml-2">Total Ticket: {ticket.length}</li>
                            </ul>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={perPage}>Previous</button>
                                </li>
                                {numbers.map((n) => (
                                    <li
                                        key={n}
                                        className={`page-item ${currentPage === n ? 'active' : ''}`}
                                    >
                                        <button className="page-link" onClick={() => changePage(n)}>
                                            {n}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === npage ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={nextPage}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
    function perPage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changePage(id) {
        setCurrentPage(id)
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
}

export default AllTicket